import { isIOS } from '@react-aria/utils'

export function isKeyboardOverlappingContent() {
  // Chrome 108 in Android brought some of the iOS behavior in regards to the virtual keyboard overlay
  return isIOS() || keyboardHeight() > 0
}

export function keyboardHeight() {
  return (navigator as any).virtualKeyboard?.boundingRect?.height ?? 0
}
